import { useEffect } from 'react';

// Third-party
import Box from '@mui/material/Box';

// Redux-toolkit
import { tasklistsActions } from '../../../../store/tasklists/slice';
import {
  getSelectedTasklistToSubmit,
} from '../../../../store/tasklists/selectors';

// Hooks
import { useAppDispatch, useAppSelector } from '../../../../hooks/useAppStore';
import { useSharedTasklists } from '../../Shared/hooks';

// Components
import { TasklistTemplateList } from '../../Shared';

// Types
import { TSubmission, TTasklist } from '../../../../types';

const ToSubmitNav = () => {
  const dispatch = useAppDispatch();
  const { tasklistsToSubmit } = useSharedTasklists();
  const selectedTasklistToSubmit = useAppSelector(getSelectedTasklistToSubmit);

  useEffect(() => {
    dispatch(tasklistsActions.setSelectedTasklistToSubmit(tasklistsToSubmit[0] || {}));
  }, []);

  const setSelectedSubmissionToSubmit = (tasklist: TTasklist) => {
    dispatch(tasklistsActions.setSelectedDailySubmission({} as TSubmission));
    dispatch(tasklistsActions.setSelectedTasklistToSubmit(tasklist));
    dispatch(tasklistsActions.setIsOpenAllSubmissionsNav(false));
  };

  return (
    <Box>
      <TasklistTemplateList
        tasklists={tasklistsToSubmit}
        selectedTasklist={selectedTasklistToSubmit}
        setSelectedTemplate={setSelectedSubmissionToSubmit}
      />
    </Box>
  );
};

export {
  ToSubmitNav,
};
